import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

export const useSkipFirstEffect = (effect: EffectCallback, deps?: DependencyList): void => {
  const firstRef = useRef(true);

  useEffect(() => {
    if (!firstRef.current) {
      return effect();
    }
    firstRef.current = false;
  }, deps);
};
